import {
  Materials
} from "@/services/warehouse.service"; //TODO: porządek z api

function searchTree(element, id) {
  if (element.id == id) {
    return element;
  } else if (element.children != null) {
    let result = null;
    for (let i = 0; result == null && i < element.children.length; i++) {
      result = searchTree(element.children[i], id);
    }
    return result;
  }
  return null;
}

const state = {
  categories: [],
  materials: []
};

const getters = {
  categories(state) {
    return state.categories;
  },
  root(state) {
    return {
      id: 0,
      name: "Kategoria nadrzędna",
      children: state.categories
    }
  },
  materials(state) {
    return state.materials;
  }
};

const actions = {
  async get({
    commit
  }) {
    const {
      data
    } = await Materials.get();
    commit('setMaterials', data.materials);
    return data.materials;
  },
  add({
    commit,
    state
  }, body) {
    return Materials.add(body)
      .then(({
        data
      }) => {
        if (body.id) {
          commit('setMaterials', [...state.materials.map((material) => {
            if (material.id === data.id) return data;
            return material;
          })]);
          return;
        }
        commit('setMaterials', [...state.materials, data]);
      });
  },
  remove({
    state,
    commit
  }, id) {
    if (!id) return;
    return Materials.remove(id)
      .then(() => {
        let removed = state.materials.filter((material) => {
          return material.id !== id
        })
        commit('setMaterials', [...removed]);
      });
  },
  async getCategories({
    commit
  }) {
    const {
      data
    } = await Materials.getCategories();
    commit('setCategories', data.materialscategories);
    return data.materialscategories;
  },
  addCategory(state, body) {
    if (!body.parent_id) delete body.parent_id;
    return Materials.addCategory(body);
  },
  removeCategory(state, id) {
    if (!id) return;
    return Materials.removeCategory(id);
  },
  editCategory(state, {
    id,
    body
  }) {
    return Materials.editCategory(id, body);
  }
};


const mutations = {
  setCategories(state, categories) {
    state.categories = categories;
  },
  setMaterials(state, materials) {
    state.materials = materials;
  },
  removeFromParent(state, {
    id,
    parent_id
  }) {
    const root = getters.root(state);
    const parent = searchTree(root, parent_id);
    parent.children = [...parent.children.filter((child) => child.id !== id)];
    state.categories = root.children;
  },
  pushToParent(state, {
    element,
    parent_id
  }) {
    const root = getters.root(state);
    const parent = searchTree(root, parent_id);
    parent.children.push(element);
    state.categories = root.children;
  },
  decrement(state, material_id) {
    let material = state.materials.find(({
      id
    }) => id == material_id);
    if (material) {
      material.quantity--;
    }
  },
  increment(state, material_id) {
    let material = state.materials.find(({
      id
    }) => id == material_id);
    if (material) {
      material.quantity++;
    }
  },
  changeQuantity(state, {
    material_id,
    change
  }) {
    let material = state.materials.find(({
      id
    }) => id == material_id);
    if (material) {
      material.quantity = material.quantity + change;
    }
  }
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};